import { DropdownMenuItem as SDropdownMenuItem } from '@/components/ui/dropdown-menu';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export function DropdownMenuItem({
  isLast,
  children,
  ...props
}: {
  isLast: boolean;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  const { onClick, key, ...otherProps } = props;
  return (
    <div key={key} {...otherProps}>
      <SDropdownMenuItem key={key} onClick={onClick}>
        {children}
      </SDropdownMenuItem>
      {!isLast && <hr className="border-neutrals-300 my-1" />}
    </div>
  );
}
